"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgDecreaseFont = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M9.112 15H4.913c-.32 1.35-.592 2.509-.734 3.116-.068.289-.43 1.05-1.388.852-.639-.132-.89-.554-.756-1.266l2.89-10.538C5.259 5.721 5.955 5 7.013 5c1.059 0 1.755.721 2.088 2.164l2.879 10.541c.098.743-.167 1.164-.796 1.263-.943.147-1.256-.563-1.325-.852-.247-1.04-.496-2.078-.747-3.116zm-.488-2c-.727-2.962-1.5-6-1.61-6-.137 0-.904 3.038-1.621 6h3.231zM15 11h6c.667.002 1 .336 1 1.002 0 .665-.333.998-1 .998h-6c-.667 0-1-.333-1-1s.333-1 1-1z' }))); };
exports.default = SvgDecreaseFont;
//# sourceMappingURL=DecreaseFont.js.map